<template>
	<b-card no-body class="mb-3">
		<b-card-header v-b-toggle="'planned-level-details-'+level">
			<font-awesome-icon icon="chevron-down" v-b-toggle="'planned-level-details-'+level" onclick="this.classList.toggle('fa-rotate-270')"></font-awesome-icon>
			<span class="h6 ml-1 mb-0">{{level | ordinal}} Level</span>
			<b-button variant="danger" size="sm" class="float-right" onClick="event.stopPropagation();" @click="$emit('discard',level)" v-if="canDelete">&times;</b-button>
		</b-card-header>
		<b-collapse visible :id="'planned-level-details-'+level">
			<b-tabs>
				<b-tab title="Stats" lazy>
					<planned-level-stats :level="level" />
				</b-tab>
				<b-tab title="Features" lazy>
					<planned-level-features :level="level" />
				</b-tab>
				<b-tab title="Skills" lazy>
					<planned-level-skills :level="level" />
				</b-tab>
				<b-tab title="Spells" lazy v-if="isCaster">
					<planned-level-spells :level="level" />
				</b-tab>
				<b-tab title="Drone" lazy v-if="hasDrone">
					<planned-level-drone :level="level" />
				</b-tab>
				<b-tab title="Companion" lazy v-if="hasCompanion">
					<planned-level-companion :level="level" />
				</b-tab>
				<b-tab title="Pools" lazy v-if="hasPools">
					<planned-level-pools :level="level" />
				</b-tab>
			</b-tabs>
		</b-collapse>
	</b-card>

</template>

<script>
import PlannedLevelStats from '@/components/planning/PlannedLevelStats.vue'
import PlannedLevelFeatures from '@/components/planning/PlannedLevelFeatures.vue'
import PlannedLevelSkills from '@/components/planning/PlannedLevelSkills.vue'
import PlannedLevelSpells from '@/components/planning/PlannedLevelSpells.vue'
import PlannedLevelDrone from '@/components/planning/PlannedLevelDrone.vue'
import PlannedLevelCompanion from '@/components/planning/PlannedLevelCompanion.vue'
import PlannedLevelPools from '@/components/planning/PlannedLevelPools.vue'

export default {
	props: [
		'level', 'data'
	],
	components: {
		PlannedLevelStats,
		PlannedLevelFeatures,
		PlannedLevelSkills,
		PlannedLevelSpells,
		PlannedLevelDrone,
		PlannedLevelCompanion,
		PlannedLevelPools,
	},
	computed: {
		currentLevel: function(){
			return this.$store.state.Character.Level
		},
		highestLevel: function(){
			return Object.keys( this.$store.state.Character.Levels ).length
		},
		canDelete: function(){
			return 	this.level != 1 && 
					this.level > this.currentLevel && 
					this.level == this.highestLevel
		},
		isCaster: function(){
			return this.$store.getters['character/spells/isCasterAtLevel'](this.level)
		},
		hasDrone: function(){
			return this.$store.getters['character/drones/hasDroneAtLevel'](this.level)
		},
		hasCompanion: function(){
			return this.$store.getters['character/companions/hasCompanionAtLevel'](this.level)
		},
		hasPools: function(){
			return this.$store.getters['character/pools/hasPoolsAtLevel'](this.level)
		}
	}
}
</script>

<style scoped>

</style>